export default "__VITE_ASSET__DWH3x73x__"